import React from 'react';

import { GuestIcon } from '@toasttab/buffet-pui-icons';
import { CountryCode } from 'libphonenumber-js';

import PhoneLink from 'src/shared/components/common/link/PhoneLink';

type DeliveryDriverInfoType = {
  driverName: string,
  driverPhotoUrl: string | null | undefined,
  driverNumber: string | null | undefined
}

export type DeliveryDriverInfoProps = {
  driverInfo?: DeliveryDriverInfoType,
  countryCode?: CountryCode,
}

const DeliveryDriverInfo = ({ driverInfo, countryCode } : DeliveryDriverInfoProps) => {
  if(!driverInfo) return <NoDriver />;

  const { driverName, driverNumber, driverPhotoUrl } = driverInfo;

  return (
    <div data-testid="driver-info">
      <div className="driverProfile">
        {driverPhotoUrl ? <img className="driverPhoto" alt="Driver Photo" src={driverPhotoUrl} /> : <GuestIcon />}
        <div className="driverName">{driverName}</div>
      </div>
      <div className="copy">You can call or text your driver to contact them if you have any questions or requests about your delivery.</div>
      {/* phone */}
      {driverNumber && <PhoneLink className="linkText phone" phoneNumber={driverNumber} countryCode={countryCode ?? 'US'} />}
    </div>
  );
};

const NoDriver = () =>
  <div data-testid="no-driver" className="noDriver">
    {/* icon */}
    <div className="icon">
      <GuestIcon />
    </div>
    {/* copy */}
    <div className="info">
      <div className="driverName" style={{ fontWeight: 'bold' }}>Driver Will Be Assigned Soon</div>
      <div className="copy">A driver will be assigned to your order once it&apos;s ready for delivery</div>
    </div>
  </div>;

export default DeliveryDriverInfo;
